import { Link } from 'react-router-dom';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { ILookupValue } from '../../../../model';

import styles from './TextFormField.module.scss';

interface IProps extends FieldRenderProps {
  href?: string;
}

export const LookupTextFormField = (fieldRenderProps: IProps) => {
  const { label, value, onChange, href } = fieldRenderProps;
  const lookupValue = value as ILookupValue;

  return (
    <div className='k-form-field'>
      <label htmlFor='#' className='k-label'>
        {label}
      </label>
      <div className='k-form-field-wrap'>
        {href ? (
          <Link className={`k-input k-input-md k-rounded-md ${styles.field} ${lookupValue?.name ? styles.link : ''}`} to={href}>
              {lookupValue?.name ? lookupValue.name : 'N/A'}
          </Link>
        ) : (
          <span className={`k-input k-input-md k-rounded-md ${styles.field}`} onChange={onChange}>
            {lookupValue?.name ? lookupValue.name : 'N/A'}
          </span>
        )}
      </div>
    </div>
  );
};
